<div class="contact-delivery-addresses">
  <div class="contact-delivery-addresses__header">
    <div class="contact-delivery-addresses__title-wrap">
      <h3 class="contact-delivery-addresses__title">
        {{ 'COMPONENTS.CONTACT_OVERVIEW.SECTION_TITLES.DELIVERY_ADDRESSES' | translate }}
      </h3>
      @if (deliveryAddressCards.length > 0) {
        <span class="contact-delivery-addresses__count">
          {{ deliveryAddressCards.length }}
        </span>
      }
    </div>

  </div>

  @if (deliveryAddressCards.length === 0 && editorMode !== 'create') {
    <div class="contact-delivery-addresses__empty-state">
      <p class="contact-delivery-addresses__empty-title">
        {{ 'COMPONENTS.CONTACT_OVERVIEW.DELIVERY_ADDRESSES.EMPTY.TITLE' | translate }}
      </p>
      <p class="contact-delivery-addresses__empty-text">
        {{ 'COMPONENTS.CONTACT_OVERVIEW.DELIVERY_ADDRESSES.EMPTY.DESCRIPTION' | translate }}
      </p>
    </div>
  } @else {
    <div class="contact-delivery-addresses__list">
      @for (card of deliveryAddressCards; track card.id) {
        <article
          class="contact-delivery-addresses__card"
          [class.contact-delivery-addresses__card--primary]="card.isPrimary && editorMode !== 'edit'"
        >
          <div class="contact-delivery-addresses__card-header">
            <div class="contact-delivery-addresses__card-main">
              <div [ngClass]="card.iconShellClass">
                @switch (card.typeIcon) {
                  @case ('truck') {
                    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                      <path d="M14 17H6V7H14V17ZM14 10H18L20 12.5V17H14V10Z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M9 17.5C9 18.3284 8.32843 19 7.5 19C6.67157 19 6 18.3284 6 17.5C6 16.6716 6.67157 16 7.5 16C8.32843 16 9 16.6716 9 17.5Z" stroke="currentColor" stroke-width="1.8"/>
                      <path d="M20 17.5C20 18.3284 19.3284 19 18.5 19C17.6716 19 17 18.3284 17 17.5C17 16.6716 17.6716 16 18.5 16C19.3284 16 20 16.6716 20 17.5Z" stroke="currentColor" stroke-width="1.8"/>
                    </svg>
                  }
                  @case ('inbox') {
                    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                      <path d="M4 12L6.5 6H17.5L20 12V18H4V12Z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M8 12H16V14C16 15.1046 15.1046 16 14 16H10C8.89543 16 8 15.1046 8 14V12Z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  }
                }
              </div>

              <div class="contact-delivery-addresses__card-title-stack">
                @if (editorMode !== 'edit' || editingAddressId !== card.id) {
                  @if (card.label) {
                    <p class="contact-delivery-addresses__card-label">{{ card.label }}</p>
                  }
                  <div class="contact-delivery-addresses__badges">
                    <span [ngClass]="card.kindBadgeClass">
                      {{ card.kindLabelKey | translate }}
                      @if (card.carrierLabel) {
                        <span class="contact-delivery-addresses__badge-separator">·</span>
                        {{ card.carrierLabel }}
                      }
                    </span>
                    @if (card.isPrimary) {
                      <span class="contact-delivery-addresses__primary-badge">
                        <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
                          <path d="m8 1.333 2.06 4.174 4.607.67-3.334 3.25.787 4.586L8 11.847l-4.12 2.166.787-4.586L1.333 6.177l4.607-.67L8 1.333Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        {{ 'COMPONENTS.CONTACT_OVERVIEW.DELIVERY_ADDRESSES.BADGES.PRIMARY' | translate }}
                      </span>
                    }
                  </div>
                  <p class="contact-delivery-addresses__card-summary">
                    {{
                      card.summary ||
                        ('COMMON.EMPTY_VALUE' | translate)
                    }}
                  </p>
                }
              </div>
            </div>

            @if (editable && (editorMode !== 'edit' || editingAddressId !== card.id)) {
              <div class="contact-delivery-addresses__actions">
                <button
                  type="button"
                  class="form-secondary-btn form-secondary-btn--compact"
                  [disabled]="isSaving || editorMode !== null"
                  (click)="startEditAddress(card.id)"
                >
                  <span class="visually-hidden">{{ 'BUTTONS.EDIT' | translate }}</span>
                  <svg class="h-4 w-4" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                    <path d="m11.833 2.5 1.667 1.667M10.833 3.5 4.167 10.167 3.5 12.5l2.333-.667L12.5 5.167 10.833 3.5Z" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </button>
              </div>
            }

            @if (editable && editorMode === 'edit' && editingAddressId === card.id) {
              <div class="contact-delivery-addresses__actions">
                <button
                  type="button"
                  class="contact-delivery-addresses__primary-toggle"
                  [class.contact-delivery-addresses__primary-toggle--active]="addressForm.form.controls.isPrimary.value"
                  [disabled]="isSaving"
                  (click)="toggleEditingPrimary()"
                >
                  <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
                    <path d="m8 1.333 2.06 4.174 4.607.67-3.334 3.25.787 4.586L8 11.847l-4.12 2.166.787-4.586L1.333 6.177l4.607-.67L8 1.333Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                  <span>
                    {{
                      (addressForm.form.controls.isPrimary.value
                        ? 'COMPONENTS.CONTACT_OVERVIEW.DELIVERY_ADDRESSES.BADGES.PRIMARY'
                        : 'COMPONENTS.CONTACT_OVERVIEW.DELIVERY_ADDRESSES.BUTTONS.MAKE_PRIMARY') | translate
                    }}
                  </span>
                </button>
                <button
                  type="button"
                  class="form-primary-btn form-primary-btn--compact"
                  [disabled]="isSaving || addressForm.form.invalid"
                  (click)="saveAddress()"
                >
                  <span class="visually-hidden">{{ 'BUTTONS.SAVE' | translate }}</span>
                  <svg class="h-4 w-4" viewBox="0 0 16 12" fill="none" aria-hidden="true">
                    <path d="M5.5 11.2L0.8 6.5L2.2 5.1L5.5 8.4L13.8 0.1L15.2 1.5L5.5 11.2Z" fill="currentColor" />
                  </svg>
                </button>
                <button
                  type="button"
                  class="form-secondary-btn form-secondary-btn--compact"
                  [disabled]="isSaving"
                  (click)="cancelEditing()"
                >
                  <span class="visually-hidden">{{ 'BUTTONS.CANCEL' | translate }}</span>
                  <svg class="h-4 w-4" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                    <path d="M12.7 4.7L11.3 3.3L8 6.6L4.7 3.3L3.3 4.7L6.6 8L3.3 11.3L4.7 12.7L8 9.4L11.3 12.7L12.7 11.3L9.4 8L12.7 4.7Z" fill="currentColor" />
                  </svg>
                </button>
                <button
                  type="button"
                  class="form-secondary-btn form-secondary-btn--compact contact-delivery-addresses__remove-button"
                  [disabled]="isSaving"
                  (click)="removeAddress(card.id)"
                >
                  <span class="visually-hidden">{{ 'BUTTONS.REMOVE' | translate }}</span>
                  <svg class="h-4 w-4" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                    <path d="M3.5 4.5h9M6.5 2.833h3M5.167 4.5v7.333m5.666-7.333v7.333M4.167 4.5l.5 8.333h6.666l.5-8.333" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </button>
              </div>
            }
          </div>

          @if (editorMode === 'edit' && editingAddressId === card.id) {
            <ng-container
              [ngTemplateOutlet]="editorTemplate"
            />
          } @else {
            <div class="contact-delivery-addresses__card-body">
              @if (card.recipientName || card.recipientPhone) {
                <div class="contact-delivery-addresses__meta-separator"></div>
                <p class="contact-delivery-addresses__recipient">
                  {{ 'COMPONENTS.CONTACT_OVERVIEW.DELIVERY_ADDRESSES.FIELDS.RECIPIENT_NAME' | translate }}:
                  @if (card.recipientName) {
                    <span> {{ card.recipientName }}</span>
                  }
                  @if (card.recipientName && card.recipientPhone) {
                    <span>, </span>
                  }
                  @if (card.recipientPhone) {
                    <span>{{ card.recipientPhone }}</span>
                  }
                </p>
              }

              @if (card.notes) {
                <p class="contact-delivery-addresses__notes">
                  {{ card.notes }}
                </p>
              }
            </div>
          }
        </article>
      }
    </div>
  }

  @if (editorMode === 'create') {
    <article class="contact-delivery-addresses__card contact-delivery-addresses__card--editing">
      <div class="contact-delivery-addresses__card-header">
        <div class="contact-delivery-addresses__card-title-stack">
          <span class="contact-delivery-addresses__kind-badge contact-delivery-addresses__kind-badge--draft">
            {{ 'COMPONENTS.CONTACT_OVERVIEW.DELIVERY_ADDRESSES.BADGES.NEW' | translate }}
          </span>
        </div>

        <div class="contact-delivery-addresses__actions">
          <button
            type="button"
            class="contact-delivery-addresses__primary-toggle"
            [class.contact-delivery-addresses__primary-toggle--active]="addressForm.form.controls.isPrimary.value"
            [disabled]="isSaving"
            (click)="toggleEditingPrimary()"
          >
            <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <path d="m8 1.333 2.06 4.174 4.607.67-3.334 3.25.787 4.586L8 11.847l-4.12 2.166.787-4.586L1.333 6.177l4.607-.67L8 1.333Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <span>
              {{
                (addressForm.form.controls.isPrimary.value
                  ? 'COMPONENTS.CONTACT_OVERVIEW.DELIVERY_ADDRESSES.BADGES.PRIMARY'
                  : 'COMPONENTS.CONTACT_OVERVIEW.DELIVERY_ADDRESSES.BUTTONS.MAKE_PRIMARY') | translate
              }}
            </span>
          </button>
          <button
            type="button"
            class="form-primary-btn form-primary-btn--compact"
            [disabled]="isSaving || addressForm.form.invalid"
            (click)="saveAddress()"
          >
            <span class="visually-hidden">{{ 'BUTTONS.SAVE' | translate }}</span>
            <svg class="h-4 w-4" viewBox="0 0 16 12" fill="none" aria-hidden="true">
              <path d="M5.5 11.2L0.8 6.5L2.2 5.1L5.5 8.4L13.8 0.1L15.2 1.5L5.5 11.2Z" fill="currentColor" />
            </svg>
          </button>
          <button
            type="button"
            class="form-secondary-btn form-secondary-btn--compact"
            [disabled]="isSaving"
            (click)="cancelEditing()"
          >
            <span class="visually-hidden">{{ 'BUTTONS.CANCEL' | translate }}</span>
            <svg class="h-4 w-4" viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <path d="M12.7 4.7L11.3 3.3L8 6.6L4.7 3.3L3.3 4.7L6.6 8L3.3 11.3L4.7 12.7L8 9.4L11.3 12.7L12.7 11.3L9.4 8L12.7 4.7Z" fill="currentColor" />
            </svg>
          </button>
        </div>
      </div>

      <ng-container
        [ngTemplateOutlet]="editorTemplate"
      />
    </article>
  }

  @if (editable) {
    <button
      type="button"
      class="form-secondary-btn form-secondary-btn--small contact-delivery-addresses__add-button"
      [disabled]="isSaving || editorMode !== null"
      (click)="startCreateAddress()"
    >
      {{ 'COMPONENTS.CONTACT_OVERVIEW.DELIVERY_ADDRESSES.BUTTONS.ADD' | translate }}
    </button>
  }
</div>

<ng-template #editorTemplate>
  <form class="contact-delivery-addresses__editor" [formGroup]="addressForm.form">
    <div class="contact-delivery-addresses__kind-toggle">
      <button
        type="button"
        class="contact-delivery-addresses__kind-toggle-button"
        [class.contact-delivery-addresses__kind-toggle-button--active]="editingKind === 'branch'"
        (click)="selectKind('branch')"
      >
        <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
          <path d="M2.667 8.333 4.333 4.333h7.334l1.666 4V12H2.667V8.333Z" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M5.333 8.333h5.334V9.667c0 .736-.597 1.333-1.334 1.333H6.667a1.333 1.333 0 0 1-1.334-1.333V8.333Z" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        {{ 'COMPONENTS.CONTACT_OVERVIEW.DELIVERY_ADDRESSES.TYPES.BRANCH' | translate }}
      </button>
      <button
        type="button"
        class="contact-delivery-addresses__kind-toggle-button"
        [class.contact-delivery-addresses__kind-toggle-button--active]="editingKind === 'address'"
        (click)="selectKind('address')"
      >
        <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
          <path d="M9.333 11.333H4.667V4.667h4.666v6.666Zm0-4.667H12l1.333 1.667v3H9.333V6.666Z" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M6 11.667a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm7.333 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" stroke="currentColor" stroke-width="1.3"/>
        </svg>
        {{ 'COMPONENTS.CONTACT_OVERVIEW.DELIVERY_ADDRESSES.TYPES.ADDRESS' | translate }}
      </button>
    </div>

    <div class="contact-delivery-addresses__grid">
      <label class="form-label contact-delivery-addresses__field">
        {{ 'COMPONENTS.CONTACT_OVERVIEW.DELIVERY_ADDRESSES.FIELDS.LABEL' | translate }}
        <input type="text" class="form-input dark:bg-neutral-800 text-neutral-900 dark:text-neutral-50" formControlName="label" />
      </label>
    </div>

    @if (editingKind === 'branch') {
      <div class="contact-delivery-addresses__grid">
        <label class="form-label contact-delivery-addresses__field">
          {{ 'COMPONENTS.CONTACT_OVERVIEW.DELIVERY_ADDRESSES.FIELDS.CARRIER' | translate }}
          <select class="form-input dark:bg-neutral-800 text-neutral-900 dark:text-neutral-50" [value]="editingCarrier ?? ''" (change)="selectCarrier(($any($event.target).value || null))">
            @for (carrier of carrierOptions; track carrier.value) {
              <option [value]="carrier.value">{{ carrier.labelKey | translate }}</option>
            }
          </select>
        </label>

        @if (editingCarrier === 'other') {
          <label class="form-label contact-delivery-addresses__field">
            {{ 'COMPONENTS.CONTACT_OVERVIEW.DELIVERY_ADDRESSES.FIELDS.CARRIER_NAME' | translate }}
            <input type="text" class="form-input dark:bg-neutral-800 text-neutral-900 dark:text-neutral-50" formControlName="carrierName" />
          </label>
        }
      </div>

      <div class="contact-delivery-addresses__grid">
        <label class="form-label contact-delivery-addresses__field">
          {{ 'INPUTS.CITY' | translate }}
          <input type="text" class="form-input dark:bg-neutral-800 text-neutral-900 dark:text-neutral-50" formControlName="branchCity" />
        </label>

        <label class="form-label contact-delivery-addresses__field">
          {{ 'COMPONENTS.CONTACT_OVERVIEW.DELIVERY_ADDRESSES.FIELDS.BRANCH_NUMBER' | translate }}
          <input type="text" class="form-input dark:bg-neutral-800 text-neutral-900 dark:text-neutral-50" formControlName="branchNumber" />
        </label>
      </div>
    } @else {
      <div class="contact-delivery-addresses__grid">
        <label class="form-label contact-delivery-addresses__field">
          {{ 'INPUTS.COUNTRY' | translate }}
          <input type="text" class="form-input dark:bg-neutral-800 text-neutral-900 dark:text-neutral-50" formControlName="country" />
        </label>

        <label class="form-label contact-delivery-addresses__field">
          {{ 'INPUTS.CITY' | translate }}
          <input type="text" class="form-input dark:bg-neutral-800 text-neutral-900 dark:text-neutral-50" formControlName="city" />
        </label>

        <label class="form-label contact-delivery-addresses__field contact-delivery-addresses__grid-span-full">
          {{ 'COMPONENTS.CONTACT_OVERVIEW.DELIVERY_ADDRESSES.FIELDS.STREET' | translate }}
          <input type="text" class="form-input dark:bg-neutral-800 text-neutral-900 dark:text-neutral-50" formControlName="street" />
        </label>

        <label class="form-label contact-delivery-addresses__field">
          {{ 'INPUTS.POSTAL_CODE' | translate }}
          <input type="text" class="form-input dark:bg-neutral-800 text-neutral-900 dark:text-neutral-50" formControlName="postalCode" />
        </label>
      </div>
    }

    <div class="contact-delivery-addresses__grid">
      <label class="form-label contact-delivery-addresses__field">
        {{ 'COMPONENTS.CONTACT_OVERVIEW.DELIVERY_ADDRESSES.FIELDS.RECIPIENT_NAME' | translate }}
        <input type="text" class="form-input dark:bg-neutral-800 text-neutral-900 dark:text-neutral-50" formControlName="recipientName" />
      </label>

      <label class="form-label contact-delivery-addresses__field">
        {{ 'COMPONENTS.CONTACT_OVERVIEW.DELIVERY_ADDRESSES.FIELDS.RECIPIENT_PHONE' | translate }}
        <input type="text" class="form-input dark:bg-neutral-800 text-neutral-900 dark:text-neutral-50" formControlName="recipientPhone" />
      </label>
    </div>

    <label class="form-label contact-delivery-addresses__field">
      {{ 'COMPONENTS.CONTACT_OVERVIEW.DELIVERY_ADDRESSES.FIELDS.NOTES' | translate }}
      <input type="text" class="form-input dark:bg-neutral-800 text-neutral-900 dark:text-neutral-50" formControlName="notes" />
    </label>
  </form>
</ng-template>

<app-toasts></app-toasts>

<ng-template #dangerTpl>
  {{ callbackError }}
</ng-template>
